const ASSETS = process.env.REACT_APP_BACKEND_URL || "";

/**
 * Turn any image reference the backend hands us into a URL the
 * frontend `<img src>` can use directly.
 *
 * Backend conventions across endpoints (verified 2026-06-14):
 *   • `itemdata.json` / `/api/planner/search` → `/api/assets/items/foo.webp`
 *     (already fully-qualified — pass through unchanged).
 *   • `tech_tree._material_image()` / `_resolve_image_url()` → same.
 *   • Legacy callers / wiki backfill → `assets/items/foo.webp` (relative).
 *   • External wikis → `https://palworld.wiki.gg/...`.
 *   • Some old shop rows still hand us a bare filename like
 *     `T_itemicon_X.webp` (assume items asset folder).
 *
 * Production note: `<img src>` doesn't go through the axios baseURL, so
 * paths that start with `/api/` need the REACT_APP_BACKEND_URL prepended
 * (axios needs none; raw HTML needs full origin).
 *
 * Returns `null` for empty/missing inputs so the callsite can render
 * a fallback chip instead of an `<img>` 404.
 */
export function resolveImg(image) {
  if (!image) return null;
  const s = String(image);
  if (s.startsWith("http://") || s.startsWith("https://")) return s;
  if (s.startsWith("/api/")) return `${ASSETS}${s}`;
  if (s.startsWith("/"))     return `${ASSETS}${s}`;
  if (s.startsWith("assets/")) return `${ASSETS}/api/${s}`;
  // Bare filename — assume an item icon under /api/assets/items/.
  return `${ASSETS}/api/assets/items/${s}`;
}
